const ENDPOINT_BASE = process.env.REACT_APP_MOCKUP_COMMENT_ENDPOINT || "";

const REVIEWER_STORAGE_KEY = "aclymate-mockup-reviewer";

const readReviewerIdentity = () => {
  const raw = window.localStorage.getItem(REVIEWER_STORAGE_KEY);
  if (!raw) {
    return { name: "", email: "" };
  }
  const parsed = JSON.parse(raw);
  return {
    name: parsed.name || "",
    email: parsed.email || "",
  };
};

const writeReviewerIdentity = ({ name, email }) =>
  window.localStorage.setItem(
    REVIEWER_STORAGE_KEY,
    JSON.stringify({ name, email }),
  );

const ensureEndpointConfigured = () => {
  if (!ENDPOINT_BASE) {
    throw new Error(
      "REACT_APP_MOCKUP_COMMENT_ENDPOINT is not set. Add it to the front-end Doppler config.",
    );
  }
};

const buildAddCommentUrl = () => `${ENDPOINT_BASE.replace(/\/$/, "")}/mockupAddComment`;

const buildListCommentsUrl = ({ hillId, scenarioId, screenRoute }) => {
  const params = new URLSearchParams({
    hillId,
    ...(scenarioId ? { scenarioId } : {}),
    ...(screenRoute ? { screenRoute } : {}),
  });
  return `${ENDPOINT_BASE.replace(/\/$/, "")}/mockupListCommentsForScreen?${params.toString()}`;
};

const parseResponseBody = async (response) => {
  const rawText = await response.text();
  try {
    return rawText ? JSON.parse(rawText) : {};
  } catch {
    return { _rawText: rawText };
  }
};

const buildErrorMessage = (data, fallback, status) => {
  if (data?.error) {
    return data.error;
  }
  if (data?._rawText) {
    return `${fallback} (${status}) — ${data._rawText.slice(0, 200)}`;
  }
  return `${fallback} (${status})`;
};

const postComment = async (payload) => {
  ensureEndpointConfigured();
  const response = await fetch(buildAddCommentUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await parseResponseBody(response);
  if (!response.ok) {
    throw new Error(
      buildErrorMessage(data, "mockupAddComment failed", response.status)
    );
  }
  return data;
};

const getCommentsForScreen = async ({ hillId, scenarioId, screenRoute }) => {
  ensureEndpointConfigured();
  const response = await fetch(
    buildListCommentsUrl({ hillId, scenarioId, screenRoute }),
    { method: "GET" },
  );
  const data = await parseResponseBody(response);
  if (!response.ok) {
    throw new Error(
      buildErrorMessage(
        data,
        "mockupListCommentsForScreen failed",
        response.status
      )
    );
  }
  return data.comments || [];
};

export {
  readReviewerIdentity,
  writeReviewerIdentity,
  postComment,
  getCommentsForScreen,
};
